require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.string.small");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

/*!
 * React With Breakpoints 3.1.3
 * https://github.com/kristof0425/react-with-breakpoints#readme
 * Copyright (c) 2019 React With Breakpoints Authors
 */
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("prop-types")) : "function" == typeof define && define.amd ? define(["react", "prop-types"], t) : "object" == typeof exports ? exports.withBreakpoints = t(require("react"), require("prop-types")) : e.withBreakpoints = t(e.React, e.PropTypes);
}("undefined" != typeof self ? self : this, function (e, t) {
  return function (e) {
    var t = {};

    function r(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        configurable: !1,
        enumerable: !0,
        get: n
      });
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e["default"];
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "dist/", r(r.s = 5);
  }([function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.withBreakpoints = t.Context = void 0;

    var n = function () {
      function e(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      return function (t, r, n) {
        return r && e(t.prototype, r), n && e(t, n), t;
      };
    }(),
        o = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];

        for (var n in r) {
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
      }

      return e;
    },
        a = r(1),
        u = d(a),
        i = d(r(2)),
        l = d(r(6));

    function d(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    function s(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    var c = t.Context = u["default"].createContext(),
        f = (t.withBreakpoints = function (e) {
      var t = function t(_t) {
        return u["default"].createElement(c.Consumer, null, function (r) {
          return u["default"].createElement(e, o({}, _t, {
            currentBreakpoint: r.currentBreakpoint
          }));
        });
      };

      return t.displayName = "withBreakpoints(" + (e.displayName || e.name || "Component") + ")", t;
    }, function (e) {
      function t() {
        var e, r, n;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var o = arguments.length, a = Array(o), u = 0; u < o; u++) {
          a[u] = arguments[u];
        }

        return r = n = s(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(a))), n.state = {
          currentBreakpoint: ""
        }, n.handleResize = function () {
          var e = window.innerWidth,
              t = n.props.breakpoints;
          e < t.small ? n.setState({
            currentBreakpoint: "small"
          }) : e < t.medium ? n.setState({
            currentBreakpoint: "medium"
          }) : e < t.large ? n.setState({
            currentBreakpoint: "large"
          }) : (e <= t.xlarge || e > t.xlarge) && n.setState({
            currentBreakpoint: "xlarge"
          });
        }, s(n, r);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, a.PureComponent), n(t, [{
        key: "componentDidMount",
        value: function value() {
          var e,
              t,
              r,
              n = (e = this.handleResize, t = 50, r = void 0, function () {
            for (var n = arguments.length, o = Array(n), a = 0; a < n; a++) {
              o[a] = arguments[a];
            }

            clearTimeout(r), r = setTimeout(function () {
              r = null, e.apply(void 0, o);
            }, t);
          });
          window.addEventListener("resize", n, {
            passive: !0
          }), this.handleResize();
        }
      }, {
        key: "componentDidUpdate",
        value: function value(e, t) {
          var r = this.props.onBreakpointChange,
              n = this.state.currentBreakpoint;
          n !== t.currentBreakpoint && r && r(n);
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          window.removeEventListener("resize", this.handleResize);
        }
      }, {
        key: "render",
        value: function value() {
          return u["default"].createElement(c.Provider, {
            value: {
              currentBreakpoint: this.state.currentBreakpoint
            }
          }, this.props.children);
        }
      }]), t;
    }());
    f.displayName = "BreakpointsProvider", f.propTypes = {
      breakpoints: i["default"].shape({
        small: i["default"].number.isRequired,
        medium: i["default"].number.isRequired,
        large: i["default"].number.isRequired,
        xlarge: i["default"].number.isRequired
      }),
      onBreakpointChange: i["default"].func,
      children: i["default"].node
    }, f.defaultProps = {
      breakpoints: l["default"]
    }, t["default"] = f;
  }, function (t, r) {
    t.exports = e;
  }, function (e, r) {
    e.exports = t;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
          t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
          r = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2],
          n = !0;
      return !r && (n = !1), e.map(function (e) {
        t === e && (n = !r);
      }), n;
    };
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = a(r(2)),
        o = a(r(8));

    function a(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    t["default"] = {
      breakpoint: n["default"].oneOf(o["default"]).isRequired,
      breakpoints: n["default"].object,
      currentBreakpoint: n["default"].string,
      children: n["default"].node
    };
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ShowAt = t.HideAt = t.BreakpointContext = t.BreakpointsProvider = void 0;
    var n = r(0);
    Object.defineProperty(t, "BreakpointContext", {
      enumerable: !0,
      get: function get() {
        return n.Context;
      }
    });
    var o = i(n),
        a = i(r(7)),
        u = i(r(9));

    function i(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    t.BreakpointsProvider = o["default"], t.HideAt = a["default"], t.ShowAt = u["default"];
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = {
      small: 744,
      medium: 1128,
      large: 1440,
      xlarge: 1 / 0
    };
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.HideAt = l;
    var n = i(r(1)),
        o = r(0),
        a = i(r(3)),
        u = i(r(4));

    function i(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    function l(e) {
      var t = e.breakpoint,
          r = e.currentBreakpoint,
          o = e.children,
          u = void 0;

      switch (r) {
        case "small":
          u = (0, a["default"])(["small", "mediumAndBelow", "largeAndBelow"], t);
          break;

        case "medium":
          u = (0, a["default"])(["medium", "mediumAndAbove", "mediumAndBelow", "largeAndBelow"], t);
          break;

        case "large":
          u = (0, a["default"])(["mediumAndAbove", "large", "largeAndBelow", "largeAndAbove"], t);
          break;

        case "xlarge":
          u = (0, a["default"])(["mediumAndAbove", "largeAndAbove", "xlarge"], t);
      }

      return u ? n["default"].createElement(n["default"].Fragment, null, o) : null;
    }

    l.propTypes = u["default"], l.displayName = "HideAt", l.defaultProps = {
      breakpoint: "",
      currentBreakpoint: "",
      children: null
    }, t["default"] = (0, o.withBreakpoints)(l);
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = ["small", "medium", "mediumAndBelow", "mediumAndAbove", "large", "largeAndBelow", "largeAndAbove", "xlarge"];
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ShowAt = l;
    var n = i(r(1)),
        o = r(0),
        a = i(r(3)),
        u = i(r(4));

    function i(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    function l(e) {
      var t = e.breakpoint,
          r = e.currentBreakpoint,
          o = e.children,
          u = void 0;

      switch (r) {
        case "small":
          u = (0, a["default"])(["small", "mediumAndBelow", "largeAndBelow"], t, !1);
          break;

        case "medium":
          u = (0, a["default"])(["medium", "mediumAndAbove", "mediumAndBelow", "largeAndBelow"], t, !1);
          break;

        case "large":
          u = (0, a["default"])(["mediumAndAbove", "large", "largeAndBelow", "largeAndAbove"], t, !1);
          break;

        case "xlarge":
          u = (0, a["default"])(["mediumAndAbove", "largeAndAbove", "xlarge"], t, !1);
      }

      return u ? n["default"].createElement(n["default"].Fragment, null, o) : null;
    }

    l.propTypes = u["default"], l.displayName = "ShowAt", l.defaultProps = {
      breakpoint: "",
      currentBreakpoint: "",
      children: null
    }, t["default"] = (0, o.withBreakpoints)(l);
  }]);
});